
import React, {useState, useCallback} from "react"

const Tabs = ({ children, preSelectedTabIndex }) => {
    // First tab is shown by default
    const [selectedTabIndex, setSelectedTabIndex] = useState(preSelectedTabIndex || 0);
    
    return (
        <div className="tab-group">
            <div className="cmm-tab-line" role="tablist">
                {children.map((item, index) => (
                <TabTitle
                    key={item.props.title}
                    title={item.props.title}
                    index={index}
                    isActive={index === selectedTabIndex}
                    setSelectedTab={setSelectedTabIndex}
                />
                ))}
            </div>

            {/* show selcted tab by index*/}
            {children[selectedTabIndex]}
        </div>
    );
};

const TabTitle = ({ title, setSelectedTab, index, isActive }) => {
    const handleOnClick = useCallback(() => {
      setSelectedTab(index);
    }, [setSelectedTab, index]);
  
    return (
        <button type="button" role="tab" aria-selected={`${isActive ? 'true' : 'false'}`} onClick={handleOnClick}>{title}</button>
    );
};

export default Tabs
